import React from 'react';
import { DialogOptions } from '../providers/DialogProvider';

export interface DialogContextContent {
  showDialog: (options: DialogOptions) => void;
}

// @ts-ignore
export default React.createContext<DialogContextContent>();
